const {cx} = require("@emotion/css");

const avoidEdges = (rect, winSize) => cx(
    rect.x < winSize.width - 400 ? "left" : "right",
    rect.y + (rect.height??0) < winSize.height - 150 ? "bottom" : "top",
);
exports.avoidEdges = avoidEdges;
